import { Box, IconButton, useTheme } from '@mui/material';
import { FC, ReactEventHandler } from 'react';

import { Image } from '../../components/image';
import RebookersImage from '../../assets/png/rebookers-2027-28.png';
import RebookersLockup from '../../assets/png/rebook-lockup.png';
import { ReactComponent as IconClose } from '../../assets/svg/cross.svg';

type RebookingModalHeaderProps = {
    onClose: ReactEventHandler;
};
export const RebookingModalHeader: FC<RebookingModalHeaderProps> = ({ onClose }) => {
    const theme = useTheme();

    return (
        <Box height="240px" position="relative">
            <Image src={RebookersImage} css={{ objectFit: 'cover' }} />
            <Box
                css={{
                    position: 'absolute',
                    inset: 0,
                    background:
                        'linear-gradient(180deg, rgba(20, 15, 15, 0.05) 0%, rgba(20, 15, 15, 0) 40%, oklch(100% 0 0 / 0.86) 100%)',
                }}
            />
            <Box
                css={{
                    position: 'absolute',
                    top: theme.spacing(4),
                    right: theme.spacing(4),
                }}
            >
                <IconButton
                    onClick={onClose}
                    css={{
                        backgroundColor: theme.palette.grey[300],
                        ':hover': { backgroundColor: theme.palette.grey[50] },
                    }}
                >
                    <IconClose />
                </IconButton>
            </Box>
            <img
                alt="Rebookers"
                src={RebookersLockup}
                css={{
                    filter: 'drop-shadow(0 2px 6px rgba(0, 0, 0, 0.15))',
                    width: '92px',
                    objectFit: 'contain',
                    position: 'absolute',
                    bottom: theme.spacing(4),
                    left: theme.spacing(4),
                    backgroundColor: 'transparent',
                }}
            />
        </Box>
    );
};
